import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import { debounce } from '@totem/utilities/debounce';

const DEBOUNCE_TIME = 300;

const styles = {
  search: {
    width: '300px',
    maxWidth: '100%',
  },
};

const DocumentSearchInput = () => {
  const { handleFilter, getFilterValue, isReady } = useContext(InputContext);
  const [searchTerm, setSearchTerm] = useState<string>('');

  // Show a restored (persisted) search once the saved filters have been applied.
  useEffect(() => {
    if (isReady) {
      setSearchTerm(getFilterValue('name'));
    }
  }, [isReady]);

  const sendSearchUpdate = useCallback(
    debounce(
      (newSearchTerm: string) => handleFilter('name', newSearchTerm),
      DEBOUNCE_TIME,
    ),
    [],
  );

  const handleSearch = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);

    sendSearchUpdate(newSearchTerm);
  };

  return (
    <Input
      prefix={<SearchOutlined />}
      placeholder="Search document name..."
      allowClear
      style={styles.search}
      value={searchTerm}
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
        handleSearch(evt.target.value ?? '')
      }
    />
  );
};

export default DocumentSearchInput;
